// wp-icons — Charts & Analytics extras (1)
// BarChart3, TrendingUp, PieChart leben in craft.js — hier nur was noch fehlt.
import { createWpIcon } from './createIcon.js';

export const TrendingDown = createWpIcon('TrendingDown', [
  ['polyline', { points: '22 17 13.5 8.5 8.5 13.5 2 7', key: 'a' }],
  ['polyline', { points: '16 17 22 17 22 11', key: 'b' }],
]);
